import AppContainer from "./AppContainer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function App() {
  return (
    <>
      <AppContainer />
      <ToastContainer />
    </>
  );
}
